<template>
    <div class="help-menu">
        <p class="menuTitle">帮助中心</p>
        <div class="menuItemP" v-for="item in helpList" :key="item.cate_id">
            <p style="color: #333333">
                <i class="el-icon-set-up"></i>{{item.cate_name}}</p>
            <p :class="helpMeunId == sub.id?'avtiveColor':''" v-for="sub,index in item.items" @click="handleHelpMeun(sub.id)">{{sub.name}}</p>
            
        </div>
    </div>
</template>
<script>
export default{
    props: ['helpMeunId'],
    data(){
        return{
            helpList: ''
        }
    },
    methods:{
      
        handleHelpMeun(id) {
            sessionStorage.setItem("helpMeunId",id)
            this.$emit('getMeunId',id)

            if(id == 48 || id == 37){
                const { href } = this.$router.resolve({
                path: "/help/orders",
               
            });
            window.open(href, '_blank');
            }
        },
    },
    created(){
        let data = {}
        this.$store.dispatch('help/listHelpByCate',data)
            .then(res => {
                let int = res.data.items.length
                if(int != 0){
                    this.helpList = res.data.items
                }
                
            })
    }
}
</script>
<style scoped lang="scss">
.help-menu{
    width: 250px;
    background: #fff;
    padding: 10px 0px 15px 0px;
    align-self: flex-start;
    .menuTitle{
        text-align: center;
        padding-bottom: 10px;
        border-bottom: 1px solid #cccccc;
    }
    .menuItemP{
        font-size: 14px;
        color: #666666;
        cursor: pointer;
        
        p{
            width: 159px;
            float: right;
            line-height: 34px;
        }
        p:nth-child(1){
            margin-top: 7px;
            font-size: 16px;
            width: 182px;
            i{
                margin-right: 7px;
                
            }
        }
        .child1Color{
           
            color: #000;
            
        }
        p:hover{
            color: #10aeff;
        }
        .avtiveColor{
            color: #10aeff;
        }
    }
}
</style>